import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_MODELS_QUERY_KEY } from './useGetModels';

import ModelsService, { FilterModelsDto } from '@/services/ModelsService';

export function useRemoveModel(filters: FilterModelsDto) {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (id: number) => ModelsService.removeModel(id),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: GET_MODELS_QUERY_KEY(filters),
      });
    },
  });

  return { removeModel: mutateAsync, isRemoving: isPending };
}
